import { superscriptSymbols } from "hyam-core/utils/superscriptSymbols";
import { useState, useRef } from "react";
import _ from "lodash";
import { withConfigure } from "hyam-core/utils/withConfigure";
import {
  styles as moduleStyles,
  animationProps,
  HyamPrismicAccordionStyles,
} from "./styles";
import { motion } from "framer-motion";
import PlusBlack from "svg/plus-16px.svg";
import MinusBlack from "svg/minus-16px.svg";

export type HyamPrismicAccordionProps = {
  styles?: Partial<HyamPrismicAccordionStyles>;
  stylesReplace?: Partial<HyamPrismicAccordionStyles>;
  openIcon?: JSX.Element;
  closeIcon?: JSX.Element;
  items: {
    title: JSX.Element;
    content: JSX.Element;
  }[];
};

const outerHeight = (el: HTMLElement) => {
  let height = el.offsetHeight;
  const style = window.getComputedStyle(el);

  return height + parseInt(style.marginTop) + parseInt(style.marginBottom);
};

const _HyamPrismicAccordion = (props: HyamPrismicAccordionProps) => {
  const styles = props.styles as HyamPrismicAccordionStyles;
  const { items, openIcon = PlusBlack, closeIcon = MinusBlack } = props;

  const contents = useRef<(HTMLElement | null)[]>([]);
  const [contentHeights, setContentHeights] = useState([] as number[]);
  const [current, setCurrent] = useState(-1);
  const handleAccordion = (i: number) => {
    i == current ? setCurrent(-1) : setCurrent(i);
  };

  const getContentHeights = () => {
    return _.map(contents.current, (content) => {
      const child = content?.children?.[0] as HTMLElement | undefined;
      if (!child) return 0;

      // adding 20px because I cannot figure out why the height is not exact...
      return outerHeight(child) + 20;
    });
  };

  return (
    <div className={styles.container}>
      <div className={styles.items}>
        {_.map(items, (item, index) => {
          const isOpen = current === index;

          const itemContainerProps = {
            ...animationProps.item,
            animate: isOpen ? "open" : "close",
          };

          return (
            <motion.div
              key={index}
              className={styles.item}
              onClick={() => handleAccordion(index)}
              {...itemContainerProps}
            >
              <div className={styles.item_title}>
                {superscriptSymbols(item.title)}
                <span className={styles.item_icon}>{isOpen ? closeIcon : openIcon}</span>
              </div>
              <motion.div
                className={styles.item_content}
                ref={(element) => {
                  contents.current[index] = element;
                  setContentHeights(getContentHeights());
                }}
                {...animationProps.item_content(contentHeights[index])}
              >
                {item.content}
              </motion.div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export const HyamPrismicAccordion = withConfigure<
  HyamPrismicAccordionProps,
  HyamPrismicAccordionStyles
>({
  componentName: "HyamPrismicAccordion",
  Component: _HyamPrismicAccordion,
  moduleStyles,
});
